import { render } from "./SimplePollPreview.vue?vue&type=template&id=a01f4e64&scoped=true"
import script from "./SimplePollPreview.vue?vue&type=script&lang=js"
export * from "./SimplePollPreview.vue?vue&type=script&lang=js"

import "./SimplePollPreview.vue?vue&type=style&index=0&id=a01f4e64&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a01f4e64"]])

export default __exports__